{
  "version": "0.2.0",
  "gitCommitHash": "b2161090871c4e33b80f98a941c88ae814da4047",
  "gitCommitShortHash": "b216109",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}